exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cxSpinner {\n  position: relative;\n  top: 0.1em;\n}\n.cxSpinner-outline {\n  fill: none;\n  stroke: #d6d6d6;\n}\n.cxSpinner-arc {\n  fill: none;\n  stroke: #adadad;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/wait/spinner.directive.less
// module id = 1482
// module chunks = 2